module.exports = __webpack_public_path__ + "img/pubimg1.46395cc8.png";